// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-code-generator {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.sessions-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 15px;
}

.sessions-header h3 {
  margin: 0;
  color: #333;
}

.user-filter {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-filter label {
  font-weight: 600;
  color: #555;
  white-space: nowrap;
}

.user-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #333;
  font-size: 14px;
  min-width: 200px;
  cursor: pointer;
}

.user-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-code-generator h2 {
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}

.generate-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 30px;
  border: 1px solid #e9ecef;
}

.generate-section h3 {
  color: #495057;
  margin-bottom: 20px;
  font-size: 1.2rem;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #495057;
}

.form-select {
  width: 100%;
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 16px;
  background-color: white;
}

.form-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.generate-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.generate-btn:hover:not(:disabled) {
  background: #0056b3;
}

.generate-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
}

.generated-code {
  margin-top: 20px;
  padding: 15px;
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 6px;
}

.generated-code h4 {
  color: #155724;
  margin-bottom: 10px;
}

.generated-code p {
  color: #155724;
  margin-bottom: 10px;
  word-break: break-all;
}

.copy-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.copy-btn:hover {
  background: #218838;
}

.sessions-section {
  margin-top: 30px;
}

.sessions-section h3 {
  color: #495057;
  margin-bottom: 20px;
  font-size: 1.2rem;
}

.no-sessions {
  text-align: center;
  color: #6c757d;
  font-style: italic;
  padding: 40px;
}

.sessions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
}

.session-card {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s;
}

.session-card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.session-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
}

.session-header h4 {
  margin: 0;
  color: #495057;
  font-size: 1.1rem;
}

.status {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status.active {
  background: #fff3cd;
  color: #856404;
}

.status.submitted {
  background: #d4edda;
  color: #155724;
}

.session-details {
  margin-bottom: 15px;
}

.session-details p {
  margin: 5px 0;
  color: #6c757d;
  font-size: 14px;
}

.session-details strong {
  color: #495057;
}

.session-actions {
  display: flex;
  gap: 10px;
}

.copy-link-btn,
.copy-code-btn {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  background: white;
  color: #495057;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.copy-link-btn:hover,
.copy-code-btn:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #6c757d;
  font-size: 18px;
}

/* Success Dialog Styles */
.success-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.success-dialog {
  background: white;
  border-radius: 12px;
  padding: 0;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.success-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px 15px;
  border-bottom: 1px solid #e9ecef;
}

.success-dialog-header h3 {
  margin: 0;
  color: #28a745;
  font-size: 1.3rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background: #f8f9fa;
  color: #333;
}

.success-dialog-content {
  padding: 20px 25px;
}

.code-display,
.url-display {
  margin-bottom: 20px;
}

.code-display label,
.url-display label {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.code-box,
.url-box {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f8f9fa;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.code-text,
.url-text {
  flex: 1 1;
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #007bff;
  word-break: break-all;
}

.copy-code-btn,
.copy-url-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}

.copy-code-btn:hover,
.copy-url-btn:hover {
  background: #0056b3;
}

.instructions {
  background: #e7f3ff;
  padding: 15px;
  border-radius: 6px;
  border-left: 4px solid #007bff;
}

.instructions h4 {
  margin: 0 0 10px 0;
  color: #0056b3;
  font-size: 1rem;
}

.instructions ul {
  margin: 0;
  padding-left: 20px;
}

.instructions li {
  margin-bottom: 5px;
  color: #333;
  font-size: 14px;
}

.success-dialog-actions {
  padding: 15px 25px 20px;
  border-top: 1px solid #e9ecef;
  text-align: right;
}

.close-dialog-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.close-dialog-btn:hover {
  background: #218838;
}

/* Responsive design for dialog */
@media (max-width: 600px) {
  .success-dialog {
    width: 95%;
    margin: 10px;
  }
  
  .code-box,
  .url-box {
    flex-direction: column;
    align-items: stretch;
  }
  
  .copy-code-btn,
  .copy-url-btn {
    align-self: flex-end;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .form-code-generator {
    padding: 15px;
  }
  
  .sessions-grid {
    grid-template-columns: 1fr;
  }
  
  .session-actions {
    flex-direction: column;
  }
  
  .session-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
} 

/* Session Status Styles */
.status.deactivated {
  background-color: #dc3545;
  color: white;
}

.session-card.deactivated {
  opacity: 0.7;
  border-color: #dc3545;
}

.session-card.deactivated .session-header h4 {
  color: #666;
}

/* Disabled Button Styles */
.copy-link-btn:disabled,
.copy-code-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.copy-link-btn:disabled:hover,
.copy-code-btn:disabled:hover {
  background-color: #6c757d;
  transform: none;
}

/* Session Card Border Colors */
.session-card.active {
  border-left: 4px solid #28a745;
}

.session-card.submitted {
  border-left: 4px solid #007bff;
}

.session-card.deactivated {
  border-left: 4px solid #dc3545;
}

/* Expire/Close Form Button Styles */
.expire-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}`, "",{"version":3,"sources":["webpack://./src/components/FormCodeGenerator.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,SAAO;EACP,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,oBAAoB;EACtB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;AACF;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV","sourcesContent":[".form-code-generator {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.sessions-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.sessions-header h3 {\n  margin: 0;\n  color: #333;\n}\n\n.user-filter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-filter label {\n  font-weight: 600;\n  color: #555;\n  white-space: nowrap;\n}\n\n.user-select {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #333;\n  font-size: 14px;\n  min-width: 200px;\n  cursor: pointer;\n}\n\n.user-select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.form-code-generator h2 {\n  color: #333;\n  margin-bottom: 30px;\n  text-align: center;\n}\n\n.generate-section {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 25px;\n  margin-bottom: 30px;\n  border: 1px solid #e9ecef;\n}\n\n.generate-section h3 {\n  color: #495057;\n  margin-bottom: 20px;\n  font-size: 1.2rem;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #495057;\n}\n\n.form-select {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #ced4da;\n  border-radius: 6px;\n  font-size: 16px;\n  background-color: white;\n}\n\n.form-select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n.generate-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.generate-btn:hover:not(:disabled) {\n  background: #0056b3;\n}\n\n.generate-btn:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n}\n\n.generated-code {\n  margin-top: 20px;\n  padding: 15px;\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  border-radius: 6px;\n}\n\n.generated-code h4 {\n  color: #155724;\n  margin-bottom: 10px;\n}\n\n.generated-code p {\n  color: #155724;\n  margin-bottom: 10px;\n  word-break: break-all;\n}\n\n.copy-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.copy-btn:hover {\n  background: #218838;\n}\n\n.sessions-section {\n  margin-top: 30px;\n}\n\n.sessions-section h3 {\n  color: #495057;\n  margin-bottom: 20px;\n  font-size: 1.2rem;\n}\n\n.no-sessions {\n  text-align: center;\n  color: #6c757d;\n  font-style: italic;\n  padding: 40px;\n}\n\n.sessions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n}\n\n.session-card {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.2s;\n}\n\n.session-card:hover {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.session-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.session-header h4 {\n  margin: 0;\n  color: #495057;\n  font-size: 1.1rem;\n}\n\n.status {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status.active {\n  background: #fff3cd;\n  color: #856404;\n}\n\n.status.submitted {\n  background: #d4edda;\n  color: #155724;\n}\n\n.session-details {\n  margin-bottom: 15px;\n}\n\n.session-details p {\n  margin: 5px 0;\n  color: #6c757d;\n  font-size: 14px;\n}\n\n.session-details strong {\n  color: #495057;\n}\n\n.session-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.copy-link-btn,\n.copy-code-btn {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ced4da;\n  background: white;\n  color: #495057;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.copy-link-btn:hover,\n.copy-code-btn:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #6c757d;\n  font-size: 18px;\n}\n\n/* Success Dialog Styles */\n.success-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.success-dialog {\n  background: white;\n  border-radius: 12px;\n  padding: 0;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n}\n\n.success-dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 25px 15px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.success-dialog-header h3 {\n  margin: 0;\n  color: #28a745;\n  font-size: 1.3rem;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.close-btn:hover {\n  background: #f8f9fa;\n  color: #333;\n}\n\n.success-dialog-content {\n  padding: 20px 25px;\n}\n\n.code-display,\n.url-display {\n  margin-bottom: 20px;\n}\n\n.code-display label,\n.url-display label {\n  display: block;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.code-box,\n.url-box {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #f8f9fa;\n  padding: 12px;\n  border-radius: 6px;\n  border: 1px solid #e9ecef;\n}\n\n.code-text,\n.url-text {\n  flex: 1;\n  font-family: 'Courier New', monospace;\n  font-weight: 600;\n  color: #007bff;\n  word-break: break-all;\n}\n\n.copy-code-btn,\n.copy-url-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background-color 0.2s;\n}\n\n.copy-code-btn:hover,\n.copy-url-btn:hover {\n  background: #0056b3;\n}\n\n.instructions {\n  background: #e7f3ff;\n  padding: 15px;\n  border-radius: 6px;\n  border-left: 4px solid #007bff;\n}\n\n.instructions h4 {\n  margin: 0 0 10px 0;\n  color: #0056b3;\n  font-size: 1rem;\n}\n\n.instructions ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.instructions li {\n  margin-bottom: 5px;\n  color: #333;\n  font-size: 14px;\n}\n\n.success-dialog-actions {\n  padding: 15px 25px 20px;\n  border-top: 1px solid #e9ecef;\n  text-align: right;\n}\n\n.close-dialog-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.close-dialog-btn:hover {\n  background: #218838;\n}\n\n/* Responsive design for dialog */\n@media (max-width: 600px) {\n  .success-dialog {\n    width: 95%;\n    margin: 10px;\n  }\n  \n  .code-box,\n  .url-box {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .copy-code-btn,\n  .copy-url-btn {\n    align-self: flex-end;\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .form-code-generator {\n    padding: 15px;\n  }\n  \n  .sessions-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .session-actions {\n    flex-direction: column;\n  }\n  \n  .session-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n  }\n} \n\n/* Session Status Styles */\n.status.deactivated {\n  background-color: #dc3545;\n  color: white;\n}\n\n.session-card.deactivated {\n  opacity: 0.7;\n  border-color: #dc3545;\n}\n\n.session-card.deactivated .session-header h4 {\n  color: #666;\n}\n\n/* Disabled Button Styles */\n.copy-link-btn:disabled,\n.copy-code-btn:disabled {\n  background-color: #6c757d;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.copy-link-btn:disabled:hover,\n.copy-code-btn:disabled:hover {\n  background-color: #6c757d;\n  transform: none;\n}\n\n/* Session Card Border Colors */\n.session-card.active {\n  border-left: 4px solid #28a745;\n}\n\n.session-card.submitted {\n  border-left: 4px solid #007bff;\n}\n\n.session-card.deactivated {\n  border-left: 4px solid #dc3545;\n}\n\n/* Expire/Close Form Button Styles */\n.expire-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
